import Rellax from 'rellax/rellax.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    /* eslint-disable no-unused-vars */
    var rellax = new Rellax('.rellax');
    /* eslint-enable no-unused-vars */

    function checkScroll(){
        var startY = $('.navbar').height() * 2; //The point where the navbar changes in px
        if ($(window).scrollTop() > startY){
            $('body').addClass('b-scrolled');
            //$('.navbar').addClass('scrolled');
            //$('.logo').css('height', 52);
            //$('.navbar').removeClass('py-3');
            //$('.navbar').addClass('py-1');
            //$('.navbar').addClass('shadow');
            /*
            if ($('body').hasClass('home')) {
                $('.navbar').removeClass('navbar-dark');
                $('.navbar').addClass('navbar-light');
                $('.navbar').addClass('bg-white');

                $('.logo-reversed').addClass('d-none');
                $('.logo-normal').removeClass('d-none');

                $('.btn-1').removeClass('btn-outline-light');
                $('.btn-1').addClass('btn-outline-dark');
                $('.btn-2').removeClass('btn-light');
                $('.btn-2').addClass('btn-dark');
            }
            */
        } else {
            $('body').removeClass('b-scrolled');
            //$('.navbar').removeClass('scrolled');
           // $('.logo').css('height', 72);
            //$('.navbar').removeClass('py-1');
            //$('.navbar').addClass('py-3');
            //$('.navbar').removeClass('shadow');
            /*
            if ($('body').hasClass('home')) {
                $('.navbar').removeClass('navbar-light');
                $('.navbar').removeClass('bg-white');
                $('.navbar').addClass('navbar-dark');
                $('.logo-reversed').removeClass('d-none');
                $('.logo-normal').addClass('d-none');
                $('.btn-1').addClass('btn-outline-light');
                $('.btn-1').removeClass('btn-outline-dark');
                $('.btn-2').addClass('btn-light');
                $('.btn-2').removeClass('btn-dark');
            }
            */
            /*
            $('.animated').removeClass('animated');
            $('.fadeInUp').removeClass('fadeInUp');
            $('.fadeInDown').removeClass('fadeInDown');
            $('.fadeIn').removeClass('fadeIn');
            */
        }
    }

    if($('.navbar').length > 0){
        $(window).on('scroll load resize', function() {
            if(!$('body').hasClass('b-nav-open')) {
                checkScroll();
            }
        });
    }

    $(document).on('click', '.gs18-Header__Hamburger.collapsed', function() {

        // the first time it opens this is true
        //if ($('.gs18-Header__Hamburger').hasClass('collapsed')) {
            $('.gs18-Header__Hamburger').removeClass('collapsed');
            $('.gs18-Header__Hamburger').removeClass('is-open-small');
            setTimeout(function() {
                $('.close').click();
            }, 200);
        //} else {
            //$('.gs18-Header__Hamburger').addClass('collapsed');
        //}

    });

    $(document).on('click', '.gs18-Header__Hamburger:not(.collapsed)', function() {
        $('.gs18-Header__Hamburger').addClass('collapsed');
        $('.gs18-Header__Hamburger').addClass('is-open-small');
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.section-callouts').waypoint(function() {
      $('.section-callouts .circle').addClass('animated fadeInDown');
      $('.section-callouts h6').addClass('animated fadeInUp');
      }, {
          offset: '65%',
    });

    $('.group-1').hover(function() {
        $('.group-1').addClass('row-highlight');
    },function() {
        $('.group-1').removeClass('row-highlight');
    });

    $('.group-2').hover(function() {
        $('.group-2').addClass('row-highlight');
    },function() {
        $('.group-2').removeClass('row-highlight');
    });

    $('.group-3').hover(function() {
        $('.group-3').addClass('row-highlight');
    },function() {
        $('.group-3').removeClass('row-highlight');
    });

    $('.group-4').hover(function() {
        $('.group-4').addClass('row-highlight');
    },function() {
        $('.group-4').removeClass('row-highlight');
    });

    $('.group-5').hover(function() {
        $('.group-5').addClass('row-highlight');
    },function() {
        $('.group-5').removeClass('row-highlight');
    });

    $('.group-6').hover(function() {
        $('.group-6').addClass('row-highlight');
    },function() {
        $('.group-6').removeClass('row-highlight');
    });

    $('section').waypoint(function() {
        var section = $(this.element).attr('id');
        $('.wrap #' + section + ' .col-text h2').addClass('animated fadeInDown');
        $('.wrap #' + section + ' .col-text h4').addClass('animated fadeInLeft');
        $('.wrap #' + section + ' .col-text h5').addClass('animated fadeInUp');
        $('.wrap #' + section + ' .col-text p').addClass('animated fadeInUp');
        $('.wrap #' + section + ' .col-text ul').addClass('animated fadeInDown');
        //$('.wrap #' + section + ' .roundel').removeClass('fadeOutUp');
        //$('.wrap #' + section + ' .roundel').addClass('animated fadeInDown');
        $('#' + section + ' .image-1').addClass('animated fadeIn');
        $('.wrap #' + section + ' .content-holder h2').addClass('animated fadeInUp');
        $('.wrap #' + section + ' .content-holder p').addClass('animated fadeInDown');
        $('.wrap #' + section + ' .content-holder a').addClass('animated fadeInUp');
        }, {
            offset: '65%',
    });

    $('#section-0').waypoint(function() {
      /* eslint-disable no-unused-vars */
      var rellax0 = new Rellax('.rellax-0');
      /* eslint-enable no-unused-vars */
      }, {
          offset: '95%',
    });

    $('#section-1').waypoint(function() {
      /* eslint-disable no-unused-vars */
      var rellax1 = new Rellax('.rellax-1');
      /* eslint-enable no-unused-vars */
      }, {
          offset: '95%',
    });

    $('.roundel').waypoint(function() {
        //var roundel = $(this.element).data('roundel');
        $(this.element).removeClass('fadeOutDown');
        $(this.element).addClass('animated fadeInDown');
        //console.log('500px from top of viewport');
        }, {
            offset: '500',
    });

    $('.roundel').waypoint(function() {
        $(this.element).removeClass('fadeInDown');
        $(this.element).addClass('fadeOutDown');
        //console.log('50px from top of viewport');
        }, {
            offset: '50',
    });

    $('.accordion h4').click(function() {
        $('.accordion h4').removeClass('active');
        $(this).toggleClass('active');
        $(this).find('i').toggleClass('fa-minus fa-plus');

        setTimeout(function() {
            $('a.collapsed .accordion_icon').removeClass('fa-minus');
            $('a.collapsed .accordion_icon').addClass('fa-plus');
        }, 200);
    });

    $('.play-video').click(function() {
        //console.log('clicked');
        $('.media-holder.image-video').removeClass('d-flex');
        $('.media-holder.image-video').addClass('d-none');
        $('.nsf-logo').addClass('d-none');
        //$('.video-holder iframe').attr('src', $('.video-holder iframe').attr('src') + '?start=1');
        $('.video-holder iframe').click();
    });

    // stop video playback on modal close
    $('body').on('hidden.bs.modal', '.video-modal', function () {
        $('.video-modal iframe').attr('src', $('.video-modal iframe').attr('src'));
    });

    // Show survey for PDF downloads
    /*
    $('a[href$=\'.pdf\']').click(function(){
        window.a_href = $(this).attr('href')   
        $('#download-modal').modal('show');
        return false;
    });
    */

    /*
    $('#download-modal .wpcf7-submit').click(function(){
        $('#download-modal').modal('hide');
        window.open(window.a_href);
    });
    */

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        /*
        if ( '4178' == event.detail.contactFormId ) {
            $('#download-modal').modal('hide');
            window.open(window.a_href);
        }
        */

        if ( '1439' == event.detail.contactFormId ) {
            $('#form_quiz').submit();
        }

        if ( '5711' == event.detail.contactFormId ) {
            $('#form_quiz').submit();
        }
    }, false );


    /* eslint-disable */
    $( 'form[name="form_survey"]' ).on( 'submit', function() {
        var form_data = $( this ).serializeArray();

        $('#multiCollapseExample3').collapse('hide');
        $( ".survey_result" ).empty();

        // Here we add our nonce (The one we created on our functions.php. WordPress needs this code to verify if the request comes from a valid source.
        form_data.push( { 'name' : 'security', 'value' : ajax_nonce } ); 
     
        // Here is the ajax petition.
        $.ajax({
            url : ajax_url,
            type : 'post',
            data : form_data,
            success : function( response ) {
                // You can craft something here to handle the message return
                // alert( response );
                console.log(response);
            },
            fail : function( err ) {
                // You can craft something here to handle an error if something goes wrong when doing the AJAX request.
                // alert( 'There was an error: ' + err );
                console.log('There was an error: ' + err );
            },
        });

        console.log(form_data[0].name);
        console.log(form_data[0].value);
        console.log(form_data[1].name);
        console.log(form_data[1].value);

        var users = form_data[0].value;
        var system = form_data[1].value;
        var daily_cost = 0;
        var yearly_cost = 0;
        var seven_year_saving = 0;
        var user_cost = 0;
        var jt_cost = 0;
        var jt_yearly_cost = 0;
        var desc = '';

        /*****  DAILY Costs *****
        ******  100 Uses A Day ****** 
        Jet Towel Slim 9                            £0.08
        Jet Towel Smart Lite (Unheated/Heated)      £0.08 / £0.09
        Old Hand Dryer (Push Button)                £0.69
        Paper Towels                                £0.80
        Roller Towel                                £1.32
        Old Hand Dryer / Paper Towels               £0.75

        £0.34 per kWh 25/11/2022
        */

        //var jt_slim = 0.03;
        var jt_smart = 0.02;
        var old_dryer = 0.20;
        var paper_towels = 0.80;
        var roller_towel = 1.32;
        var mixed = 0.50;

        if(users == '100') {
            user_cost = 1;
        } else if(users == '250') {
            user_cost = 2.5;
        } else if(users == '500') {
            user_cost = 5;
        }

        if(system == 'Paper Towels') {
            daily_cost = paper_towels * user_cost;
            desc = 'Paper towel dispensers have long been in use, however they are costly, high maintenance and require continual waste management in order to prevent a build-up of bacteria. 254 million tons are sent to landfill every year globally and 17 trees are cut down for every ton of paper towels made.';
        } else if(system == 'Roller Towel') {
            daily_cost = roller_towel * user_cost;
            desc = 'Roller towels have long been in use, however they are costly, high maintenance and require continual management in order to prevent a build-up of bacteria.';
        } else if(system == 'Old Hand Dryer') {
            daily_cost = old_dryer * user_cost;
            desc = 'Old style push button hand dryers are noisy, can be unhygienic and have poor energy efficiency.';
        } else if(system == 'Mixed') {
            daily_cost = mixed * user_cost;
            desc = 'A mixed approach to hand drying can leave you with increased costs, waste management and an unhygienic washroom.';
        }

        jt_cost = jt_smart * user_cost;
        jt_yearly_cost = jt_cost * 365;
        yearly_cost = daily_cost * 365;
        seven_year_saving = (yearly_cost - jt_yearly_cost) * 7;

        $('.hands_in').toggle();
        $('.survey_intro').toggle();
        $('.survey_result').toggle();

        $('<h2>Save £'+ seven_year_saving.toFixed(2) +'<sup>*</sup> With Wave i01</h2>').appendTo('.survey_result');
        $('<p>'+ desc +'</p>').appendTo('.survey_result');
        $('<h3>Yearly Costs</h3>').appendTo('.survey_result');
        $('<table class="table table-savings text-center mb-4"> \
            <tr class="table-header"> \
                <th>'+ system +'</th> \
                <th>Mitsubishi Electric Wave</th> \
            </tr> \
            <tr> \
                <td class="font-weight-bold">£'+ yearly_cost.toFixed(2) +'</td> \
                <td class="font-weight-bold">£'+ jt_yearly_cost.toFixed(2) +'</td> \
            </tr> \
        </table>').appendTo('.survey_result');
        $('<p class="small">*Over a seven year period</p>').appendTo('.survey_result');
        $('<a class="btn btn-dark rounded-pill mr-1" data-dismiss="modal" data-toggle="modal" data-target="#modal-buy" href="#modal-buy">Buy Now <i class="fa fa-caret-right" aria-hidden="true"></i></a>').appendTo('.survey_result');
        $('<a href="/wave-i01/" class="btn btn-outline-dark rounded-pill mr-1">More Information <i class="fa fa-caret-right" aria-hidden="true"></i></a>').appendTo('.survey_result');
        $('<a href="#" id="restart-survey" class="restart-survey btn btn-text mt-4 pl-0">Start Again <i class="fa fa-caret-right" aria-hidden="true"></i></a>').appendTo('.survey_result');

        return false;
    });

    $("input.form-check-input").focus( function() {
        $('.selected').removeClass('selected');
        $(this.parentNode).addClass('selected');
    });



    //function quiz() {

    $( 'form[name="form_quiz"]' ).on( 'submit', function() {
        console.log('submitted');
        var form_data = '';
        form_data = $( this ).serializeArray();

        $('#multiCollapseQuiz9').collapse('hide');
        $('.quiz_result').empty();

        // Here we add our nonce (The one we created on our functions.php. WordPress needs this code to verify if the request comes from a valid source.
        //form_data.push( { 'name' : 'security', 'value' : ajax_nonce } ); 
     
        // Here is the ajax petition.
        //$.ajax({
            //url : ajax_url,
            //type : 'post',
            //data : form_data,
            //success : function( response ) {
                // You can craft something here to handle the message return
                // alert( response );
                //console.log(response);
            //},
            //fail : function( err ) {
                // You can craft something here to handle an error if something goes wrong when doing the AJAX request.
                // alert( 'There was an error: ' + err );
                //console.log('There was an error: ' + err );
           // },
       // });

        /*
        console.log(form_data[0].name);
        console.log(form_data[0].value);
        console.log(form_data[1].name);
        console.log(form_data[1].value);
        */

        console.log(form_data);

        var score = 0;
        var q1 = '';
        var q2 = '';
        var q3 = '';
        var q4 = '';
        var q5 = '';
        var q6 = '';
        var q7 = '';
        var q8 = '';

        $(form_data).each(function(i, field){
            console.log(field.name);
            console.log(field.value);

            if(field.name == 'q1') {
                q1 = field.value;
            }
            else if(field.name == 'q2') {
                q2 = field.value;
            }
            else if(field.name == 'q3') {
                q3 = field.value;
            }
            else if(field.name == 'q4') {
                q4 = field.value;
            }
            else if(field.name == 'q5') {
                q5 = field.value;
            }
            else if(field.name == 'q6') {
                q6 = field.value;
            }
            else if(field.name == 'q7') {
                q7 = field.value;
            }
            else if(field.name == 'q8') {
                q8 = field.value;
            }
        });


        if(q1 == 'Katrina And The Waves') {
            score++;
        }

        if(q2 == 'Edward Scissorhands') {
            score++;
        }

        if(q3 == 'Ginger Spice') {
            score++;
        }

        if(q4 == 'The Fresh Prince of Bel-Air') {
            score++;
        }

        if(q5 == 'Mighty Morphin Power Rangers') {
            score++;
        }

        if(q6 == 'Sonic the Hedgehog') {
            score++;
        }

        if(q7 == 'Enjoy the Silence') {
            score++;
        }

        if(q8 == 'U Cant Touch This') {
            score++;
        }

        $('.quiz_intro').toggle();
        $('.quiz_result').toggle();

        $('<h3>Your Score</h3>').appendTo('.quiz_result');
        $('<h5 class="display-1 mb-4">'+ score +' / 8</h5>').appendTo('.quiz_result');
        $('<button type="button" class="btn btn-dark rounded-pill mx-2" data-dismiss="modal" aria-label="Close">Back To Website</button>').appendTo('.quiz_result');
        $('<a href="#" id="restart-quiz" class="restart-survey btn btn-light rounded-pill mx-2">Try Again <i class="fa fa-caret-right" aria-hidden="true"></i></a>').appendTo('.quiz_result');

        return false;
    });


    $(document).on('click', '#restart-survey', function() {
        $('.hands_in').toggle();
        $('.survey_intro').toggle();
        $('.survey_result').toggle();
        $('#multiCollapseExample1').collapse('show');

        return false;
    });


    $(document).on('click', '#restart-quiz', function() {
        $('.quiz_intro').toggle();
        $('.quiz_result').toggle();
        $('#multiCollapseQuiz1').collapse('show');

        return false;
    });

    /* eslint-enable */

/*
    // in
    $('section').waypoint(function() {
        var section = $(this.element).attr('id');
        $('.wrap #' + section + ' .roundel-0').addClass('animated fadeInDown');
        console.log('400');
        }, {
            offset: '400',
    });

    $('section').waypoint(function() {
        var section = $(this.element).attr('id');
        $('.wrap #' + section + ' .roundel-1').addClass('animated fadeInDown');
        console.log('100');
        }, {
            offset: '100',
    });


    // out
    $('section').waypoint(function() {
        var section = $(this.element).attr('id');
        $('.wrap #' + section + ' .roundel-0').removeClass('fadeInDown');
        $('.wrap #' + section + ' .roundel-0').addClass('fadeOutDown');
        console.log('-100');
        }, {
            offset: '-100',
    });

    $('section').waypoint(function() {
        var section = $(this.element).attr('id');
        $('.wrap #' + section + ' .roundel-1').removeClass('fadeInDown');
        $('.wrap #' + section + ' .roundel-1').addClass('fadeOutDown');
        console.log('-600');
        }, {
            offset: '-600',
    });
*/

/*
    function checkScroll(){
      var startY = $('.navbar').height() * 2; //The point where the navbar changes in px
      if ($(window).scrollTop() > startY){
          $('body').addClass('b-scrolled');
          $('.navbar').addClass('scrolled');
          //$('.logo').css('width', 130);
      } else {
          $('body').removeClass('b-scrolled');
          $('.navbar').removeClass('scrolled');
          //$('.logo').css('width', 150);
          $('.animated').removeClass('animated');
          $('.fadeInUp').removeClass('fadeInUp');
          $('.fadeInDown').removeClass('fadeInDown');
          $('.fadeIn').removeClass('fadeIn');
      }
  }

  if($('.navbar').length > 0){
    $(window).on('scroll load resize', function() {
      if(!$('body').hasClass('b-nav-open')) {
          checkScroll();
      }
    });
  }
*/

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js